import { AccountManagerComponent } from './account-manager.component';
import { LoadingComponent } from './features/loading/loading.component';
import { HasAmsFeatureGuard } from './guards/has-ams-feature.guard';
import { AuthGuard } from '@tmx/auth';
import { Route } from '@angular/router';

export const accountManagerRoutes: Route[] = [
  {
    path: 'terms',
    loadComponent: () =>
      import('./components/accept-terms/accept-terms.component'),
  },
  {
    path: '',
    component: AccountManagerComponent,
    canActivate: [AuthGuard()],
    children: [
      {
        path: 'loading',
        component: LoadingComponent,
      },
      {
        path: 'dashboard',
        loadChildren: async () =>
          import('./features/dashboard/dashboard.routes'),
        canActivate: [HasAmsFeatureGuard],
        data: { preload: true },
      },
      {
        path: 'fleetaccounts',
        loadChildren: async () =>
          import('./features/fleet-accounts/fleet-accounts.routes'),
        canActivate: [HasAmsFeatureGuard],
      },
      {
        path: 'assets',
        loadChildren: async () => import('./features/assets/assets.routes'),
        canActivate: [HasAmsFeatureGuard],
      },
      {
        path: 'cfs',
        loadChildren: async () => import('./features/cfs/cfs.routes'),
        canActivate: [HasAmsFeatureGuard],
      },
      {
        path: 'account',
        redirectTo: 'manage-account',
      },
      {
        path: 'manage-account',
        loadChildren: async () =>
          import('./features/manage-account/manage-account.routes'),
        canActivate: [HasAmsFeatureGuard],
        data: { preload: true },
      },
      {
        path: 'weather',
        canActivate: [HasAmsFeatureGuard],
        loadComponent: () => import('./features/weather/weather.component'),
      },
      {
        path: 'reporting',
        loadChildren: async () =>
          import('./features/reporting/reporting.routes'),
        canActivate: [HasAmsFeatureGuard],
      },
      {
        path: 'diagnostics',
        loadChildren: async () =>
          import('./features/diagnostics/diagnostics.routes'),
        canActivate: [HasAmsFeatureGuard],
      },
      { path: '**', redirectTo: '/ams/loading' },
    ],
  },
  { path: '**', redirectTo: '/ams/loading' },
] as Route[];
